





































































import {Component, Vue} from "vue-property-decorator";
import {AxiosResponse} from "axios";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import CategoriesSelect from "@/components/inputs/CategoriesSelect.vue";
import CategoryViewSelect from "@/components/inputs/CategoryViewSelect.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import {CategoryShowEntity} from "@/entity/CategoryShowEntity";
import {ActionsEnum} from "@/entity/ActionsEnum";
import LetEditable from "@/components/LetEditable.vue";
import ImageShow from "@/components/ImageShow.vue";
interface categoryView{
    "category_view_id": number;
    "title": string;
}
@Component({
    components: {
        ImageShow,
        LetEditable,
        DeleteButton,EForm,Number,CategoriesSelect,CategoryViewSelect,TextField,Id
    }
})
export default class CategoryShow extends  Vue{
    categoryViews:categoryView[] | null = null;
    category_view_id : number | null = null;
    categories : CategoryShowEntity[] | null = null;
    categoriesNonFiltered:CategoryShowEntity[] = [];
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = ActionsEnum.CategoryShow;
    action:string = this.baseAction;
    data : CategoryShowEntity = new CategoryShowEntity();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "id"
        },
        {text: "Resim", value: "thumb_image_url"},
        {text: "CatId", value: "cat_id"},
        {text: "Gözüken başlık", value: "title"},
        {text: "Kategorı adı", value: "cat_title"},
        {text: "Sıra", value: "no"},
        {text: "İşlemler", value: "actions"}
    ];
    filterShowCat(){
        this.categories = this.categoriesNonFiltered.filter(cat=>cat.category_view_id == this.category_view_id);
    }
    edit(item:CategoryShowEntity){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new CategoryShowEntity();
        this.dialog = true;
    }
    getCategoryShow(){
        this.dialog = false;
        this.$http.get("categoryShow").then((response:AxiosResponse)=>{
            this.categories = response.data;
            this.categoriesNonFiltered = response.data;
            if(this.category_view_id != null){
                this.filterShowCat();
            }
        });
    }
    getCategoryView(){
        this.$http.get("categoryView").then((response:AxiosResponse)=>{
            this.categoryViews = response.data;
        });
    }
    created(){
        this.getCategoryShow();
        this.getCategoryView();
    }
};
